import { gsap, refreshScroll } from '@/animations/gsap'
import { scrollEffects } from '@/animations/reveal'

/**
 * Equivalente Vue 2 de useGsap: todo lo que se cree dentro de `motion()`
 * (tweens, ScrollTriggers, SplitText) queda acotado al componente y se
 * revierte en beforeDestroy.
 */
export default {
  mounted() {
    this.$_motionCtx = gsap.context(() => {}, this.$el)
  },
  beforeDestroy() {
    if (this.$_motionCtx) this.$_motionCtx.revert()
  },
  methods: {
    motion(fn) {
      if (!this.$_motionCtx) return undefined
      return this.$_motionCtx.add(fn)
    },
    // Reveals declarativos (data-reveal / data-parallax) del componente.
    revealContent() {
      this.$nextTick(() => {
        this.motion(() => scrollEffects(this.$el))
        refreshScroll()
      })
    }
  }
}
